'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('antd/components/cascader/style');

var _cascader = require('antd/components/cascader');

var _cascader2 = _interopRequireDefault(_cascader);

var _style2 = require('antd/components/transfer/style');

var _transfer = require('antd/components/transfer');

var _transfer2 = _interopRequireDefault(_transfer);

var _style3 = require('antd/components/locale-provider/style');

var _localeProvider = require('antd/components/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _style4 = require('antd/components/card/style');

var _card = require('antd/components/card');

var _card2 = _interopRequireDefault(_card);

var _style5 = require('antd/components/time-picker/style');

var _timePicker = require('antd/components/time-picker');

var _timePicker2 = _interopRequireDefault(_timePicker);

var _style6 = require('antd/components/calendar/style');

var _calendar = require('antd/components/calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _style7 = require('antd/components/input/style');

var _input = require('antd/components/input');

var _input2 = _interopRequireDefault(_input);

var _style8 = require('antd/components/form/style');

var _form = require('antd/components/form');

var _form2 = _interopRequireDefault(_form);

var _style9 = require('antd/components/spin/style');

var _spin = require('antd/components/spin');

var _spin2 = _interopRequireDefault(_spin);

var _style10 = require('antd/components/col/style');

var _col = require('antd/components/col');

var _col2 = _interopRequireDefault(_col);

var _style11 = require('antd/components/row/style');

var _row = require('antd/components/row');

var _row2 = _interopRequireDefault(_row);

var _style12 = require('antd/components/icon/style');

var _icon = require('antd/components/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style13 = require('antd/components/button/style');

var _button = require('antd/components/button');

var _button2 = _interopRequireDefault(_button);

var _style14 = require('antd/components/timeline/style');

var _timeline = require('antd/components/timeline');

var _timeline2 = _interopRequireDefault(_timeline);

var _style15 = require('antd/components/menu/style');

var _menu = require('antd/components/menu');

var _menu2 = _interopRequireDefault(_menu);

var _style16 = require('antd/components/badge/style');

var _badge = require('antd/components/badge');

var _badge2 = _interopRequireDefault(_badge);

var _style17 = require('antd/components/upload/style');

var _upload = require('antd/components/upload');

var _upload2 = _interopRequireDefault(_upload);

var _style18 = require('antd/components/tree-select/style');

var _treeSelect = require('antd/components/tree-select');

var _treeSelect2 = _interopRequireDefault(_treeSelect);

var _style19 = require('antd/components/tree/style');

var _tree = require('antd/components/tree');

var _tree2 = _interopRequireDefault(_tree);

var _style20 = require('antd/components/validation/style');

var _validation = require('antd/components/validation');

var _validation2 = _interopRequireDefault(_validation);

var _style21 = require('antd/components/alert/style');

var _alert = require('antd/components/alert');

var _alert2 = _interopRequireDefault(_alert);

var _style22 = require('antd/components/notification/style');

var _notification = require('antd/components/notification');

var _notification2 = _interopRequireDefault(_notification);

var _style23 = require('antd/components/radio/style');

var _radio = require('antd/components/radio');

var _radio2 = _interopRequireDefault(_radio);

var _style24 = require('antd/components/queue-anim/style');

var _queueAnim = require('antd/components/queue-anim');

var _queueAnim2 = _interopRequireDefault(_queueAnim);

var _style25 = require('antd/components/slider/style');

var _slider = require('antd/components/slider');

var _slider2 = _interopRequireDefault(_slider);

var _style26 = require('antd/components/message/style');

var _message = require('antd/components/message');

var _message2 = _interopRequireDefault(_message);

var _style27 = require('antd/components/collapse/style');

var _collapse = require('antd/components/collapse');

var _collapse2 = _interopRequireDefault(_collapse);

var _style28 = require('antd/components/table/style');

var _table = require('antd/components/table');

var _table2 = _interopRequireDefault(_table);

var _style29 = require('antd/components/checkbox/style');

var _checkbox = require('antd/components/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _style30 = require('antd/components/switch/style');

var _switch = require('antd/components/switch');

var _switch2 = _interopRequireDefault(_switch);

var _style31 = require('antd/components/input-number/style');

var _inputNumber = require('antd/components/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _style32 = require('antd/components/steps/style');

var _steps = require('antd/components/steps');

var _steps2 = _interopRequireDefault(_steps);

var _style33 = require('antd/components/pagination/style');

var _pagination = require('antd/components/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _style34 = require('antd/components/popconfirm/style');

var _popconfirm = require('antd/components/popconfirm');

var _popconfirm2 = _interopRequireDefault(_popconfirm);

var _style35 = require('antd/components/breadcrumb/style');

var _breadcrumb = require('antd/components/breadcrumb');

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _style36 = require('antd/components/select/style');

var _select = require('antd/components/select');

var _select2 = _interopRequireDefault(_select);

var _style37 = require('antd/components/popover/style');

var _popover = require('antd/components/popover');

var _popover2 = _interopRequireDefault(_popover);

var _style38 = require('antd/components/progress/style');

var _progress = require('antd/components/progress');

var _progress2 = _interopRequireDefault(_progress);

var _style39 = require('antd/components/dropdown/style');

var _dropdown = require('antd/components/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _style40 = require('antd/components/modal/style');

var _modal = require('antd/components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _style41 = require('antd/components/tabs/style');

var _tabs = require('antd/components/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _style42 = require('antd/components/carousel/style');

var _carousel = require('antd/components/carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _style43 = require('antd/components/tag/style');

var _tag = require('antd/components/tag');

var _tag2 = _interopRequireDefault(_tag);

var _style44 = require('antd/components/tooltip/style');

var _tooltip = require('antd/components/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _style45 = require('antd/components/date-picker/style');

var _datePicker = require('antd/components/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _style46 = require('antd/components/affix/style');

var _affix = require('antd/components/affix');

var _affix2 = _interopRequireDefault(_affix);

var _style47 = require('antd/components/rate/style');

var _rate = require('antd/components/rate');

var _rate2 = _interopRequireDefault(_rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// copy from above
var antd = {
  Rate: _rate2["default"], Affix: _affix2["default"], DatePicker: _datePicker2["default"], Tooltip: _tooltip2["default"], Tag: _tag2["default"], Carousel: _carousel2["default"], Tabs: _tabs2["default"], Modal: _modal2["default"], Dropdown: _dropdown2["default"], Progress: _progress2["default"], Popover: _popover2["default"], Select: _select2["default"],
  Breadcrumb: _breadcrumb2["default"], Popconfirm: _popconfirm2["default"], Pagination: _pagination2["default"], Steps: _steps2["default"], InputNumber: _inputNumber2["default"], Switch: _switch2["default"], Checkbox: _checkbox2["default"], Table: _table2["default"], Collapse: _collapse2["default"], message: _message2["default"],
  Slider: _slider2["default"], QueueAnim: _queueAnim2["default"], Radio: _radio2["default"], notification: _notification2["default"], Alert: _alert2["default"], Validation: _validation2["default"], Tree: _tree2["default"], TreeSelect: _treeSelect2["default"], Upload: _upload2["default"],
  Badge: _badge2["default"], Menu: _menu2["default"], Timeline: _timeline2["default"], Button: _button2["default"], Icon: _icon2["default"], Row: _row2["default"], Col: _col2["default"], Spin: _spin2["default"], Form: _form2["default"], Input: _input2["default"], Calendar: _calendar2["default"], TimePicker: _timePicker2["default"],
  Card: _card2["default"], LocaleProvider: _localeProvider2["default"], Transfer: _transfer2["default"], Cascader: _cascader2["default"]
}; /* eslint no-console:0 */
// this file is not used if use https://github.com/ant-design/babel-plugin-antd

if (process.env.NODE_ENV !== 'production') {
  if (typeof console !== 'undefined' && console.warn) {
    console.warn('you are using prebuild antd,\nplease use https://github.com/ant-design/babel-plugin-antd to reduce app bundle size.');
  }
}

exports["default"] = antd;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 282
 ** module chunks = 0
 **/